import React from "react";
import styled from "styled-components";

import { IStreamData } from "@formant/core/model/IStreamData";
import { spacing5, spacing10 } from "@formant/ui/component/common/Spacing";

import { deviceStore } from "../../../stores";
import { findNearestDataPoint } from "../../../utils/findNearestDataPoint";
import { Scrollable } from "../../common/Scrollable";
import { Value } from "../NumericSet/Value";

const ValueContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${spacing10} 0 ${spacing10} 0;
`;

const ValuePadding = styled.div`
    padding: ${spacing5} 0 ${spacing5} 0;
`;

interface ISimpleNumericModuleProps {
    streamData: IStreamData<"numeric">[];
    time: Date;
}

export default function SimpleNumericModule(props: ISimpleNumericModuleProps) {
    const { streamData, time } = props;
    const nearest = streamData.map(_ => {
        const device = deviceStore.get(_.deviceId);
        return {
            deviceName: device ? device.name : "",
            nearestPoint: findNearestDataPoint(_.points, time),
        };
    });
    return (
        <Scrollable>
            <ValueContainer>
                {nearest.map(_ =>
                    _.nearestPoint ? (
                        <ValuePadding key={_.deviceName}>
                            <Value
                                value={_.nearestPoint[1]}
                                label={_.deviceName}
                            />
                        </ValuePadding>
                    ) : null,
                )}
            </ValueContainer>
        </Scrollable>
    );
}
